<template>
  <div class="ledger-page ledger-report-print">
    <div class="ledger-report-layout">
      <nav class="ledger-report-nav">
        <b-link
          v-for="item in items"
          :key="item.name"
          class="d-block mb-50"
          :to="{ name: item.name }"
        >
          {{ $t(item.title) }}
        </b-link>
      </nav>
      <div class="ledger-report-body">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  name: 'ReportLayout',
  components: { BLink },
  computed: {
    items() {
      const rows = [
        { name: 'ledger-report-daily', title: 'ledger_rep_daily', permission: 'financial reports' },
        { name: 'ledger-report-profit', title: 'ledger_rep_profit', permission: 'financial reports' },
        { name: 'ledger-report-financial-position', title: 'ledger_fp_title', permission: 'financial reports' },
        { name: 'ledger-report-centers', title: 'ledger_rep_centers', permission: 'financial reports' },
        { name: 'ledger-report-projects', title: 'ledger_rep_projects', permission: 'financial reports' },
        { name: 'ledger-report-pack', title: 'ledger_rep_pack', permission: 'financial reports' },
        { name: 'ledger-report-aging', title: 'ledger_rep_aging', permission: 'financial reports' },
        { name: 'ledger-report-contracts', title: 'ledger_rep_contract_status', permission: 'view contracts' },
        { name: 'ledger-report-subcontractors', title: 'ledger_rep_sub_balances', permission: 'view subcontractors' },
        { name: 'ledger-report-close-status', title: 'ledger_close_status_title', permission: 'view accounting_periods' },
        { name: 'ledger-report-employee', title: 'ledger_rep_employee', permission: 'view employee_reports' },
      ]
      return rows.filter(row => this.hasPermission(row.permission))
    },
  },
}
</script>

<style scoped>
.ledger-report-layout { display: block; }
.ledger-report-nav { margin-bottom: 1rem; }
@media (min-width: 1280px) {
  .ledger-report-layout { display: grid; grid-template-columns: 220px 1fr; gap: 1rem; }
}
@media print {
  .ledger-report-nav { display: none !important; }
}
</style>
